import { createContext, useState } from "react"
import { useMutation } from 'react-query';
import {
    searchAdminUser,
} from "../api/apiServices";
import toast from 'react-hot-toast'

const AdminUserSearchContext = createContext({})

export const AdminUserSearchProvider = ({ children }) => {

    const [searchResult, setSearchResult] = useState({
        search: false,
        adminUser: [],
        mobile_number: "",
        email: "",
        first_name: "",
        last_name: "",
    })

    const [phone_input_name, setPhoneInputName] = useState("")

    const searchMutation = useMutation(searchAdminUser, {
        onSuccess: async (res) => {
            if (res.status) {
                setSearchResult(prevData => ({
                    ...prevData,
                    adminUser: res.admin_user,
                    search: true,
                    // mobile_number: "",
                    // email: "",
                    // first_name: "",
                    // last_name: "",
                }))
            } else {
                toast.error(res.message, {
                    duration: 5000,
                    className: "toast-message",
                })
                setSearchResult(prevData => ({
                    ...prevData,
                    adminUser: [],
                    search: false,
                    // mobile_number: "",
                    // email: "",
                    // first_name: "",
                    // last_name: "",
                }))
                return false
            }
        },
        onError: async (err) => {
            toast.error(err.message, {
                duration: 5000,
                className: "toast-message",
            })
        }
    })

    const handleSearch = async (e) => {
        e.preventDefault();

        const searchData = {
            email: searchResult.email,
            mobile_number: searchResult.mobile_number,
            first_name: searchResult.first_name,
            last_name: searchResult.last_name,
        }
        searchMutation.mutate(searchData)
    }

    const handlePhoneInputName = (e) => {
        const name = e.target.placeholder
        setPhoneInputName(name)
    }

    const handlePhoneChange = (value,
        countryObj,
        e,
        formattedValue) => {
       
        const name = e.target.name
        // const name = phone_input_name ? phone_input_name : undefined
        setSearchResult(prevData => ({
            ...prevData,
            [name]: value
        }))
    }

    const handleChange = e => {
        const name = e.target.name
        const value = e.target.value
        setSearchResult(prevData => ({
            ...prevData,
            [name]: value
        }))
    }

    const handleCancel = (e) => {
        setSearchResult(prevData => ({
            ...prevData,
            search: false,
            adminUser: [],
        }))
        // navigate(-1);
    }

    return (
        <AdminUserSearchContext.Provider value={{
            searchResult,
            setSearchResult,
            handleSearch,
            handlePhoneInputName,
            handlePhoneChange,
            handleChange,
            handleCancel
        }}>
            {children}
        </AdminUserSearchContext.Provider>
    )
}

export default AdminUserSearchContext 